import api, { paginado } from './apiClient'

// -------------------------------------------------------------- Usuários ----

/** `GET /users?subCompanyId` — leitura delegada ao SSO. */
export const getEmployeeService = async subCompanyId => {
  const response = await api.get('/users', { params: { subCompanyId } })
  return { data: paginado(response) }
}

/**
 * Épico 23: cadastro de usuário é exclusivo do SSO. A API de produção só lê.
 */
const escritaNoSso = mensagem => async () => {
  throw new Error(mensagem)
}

export const createEmployeeService = escritaNoSso(
  'Criação de usuário não existe no contrato da API. O cadastro pertence ao SSO.'
)

export const editEmployeeService = escritaNoSso(
  'Edição de usuário não existe no contrato da API. O cadastro pertence ao SSO.'
)

export const deleteEmployeeService = escritaNoSso(
  'Exclusão de usuário não existe no contrato da API. O cadastro pertence ao SSO.'
)

export const getEmployeeRoleService = escritaNoSso(
  'Roles por usuário não existem no contrato da API. Consulte o painel do SSO.'
)

export const addEmployeeRoleService = escritaNoSso(
  'Atribuição de role não existe no contrato da API. Use o painel do SSO.'
)

export const deleteEmployeeRoleService = escritaNoSso(
  'Remoção de role não existe no contrato da API. Use o painel do SSO.'
)

// ------------------------------------------------------------- Auditoria ----

/**
 * `GET /audit` — trilha das operações de escrita da própria API. Histórico
 * anterior à API não existe no legado.
 */
export const getLogs = async ({ from, to, user, operation, limit = 100, offset = 0 } = {}) => {
  const response = await api.get('/audit', {
    params: {
      from: from || undefined,
      to: to || undefined,
      user: user || undefined,
      operation: operation || undefined,
      limit,
      offset,
    },
  })
  return { data: paginado(response) }
}

// ---------------------------------------------------------------- Filiais ---

/** `GET /subcompanies` — filiais do perfil autenticado. */
export const getSubCompanyCompanyIdService = async () => {
  const response = await api.get('/subcompanies')
  return { data: paginado(response) }
}
